export const selectSearchFetching = (state) => state.search?.isFetching?.fetching && state.search?.isFetching?.page === 1;
export const selectSearch = (state) => state.search?.items || [];
export const selectSearchHasMore = (state) => state.search?.hasMore || false;
export const selectSearchFromContext = (state) => state.search?.fromContext;
export const selectSearchToContext = (state) => state.search?.toContext;
